import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BackNavigation, Button, Typography } from 'src/components/common';
import {
  ApplicantDetails,
  ApplicationFormStep,
  ApplyProgramProgramDetails,
  TApplicationDetailsFormValues,
  TApplicationFormStepSectionItem,
  TopNavigation
} from 'src/components/company/programs/applyToProgramExternal';
import CompanyInfoCard from 'src/components/company/companyinfo/CompanyInfoCard';
import { colors } from 'src/constants';
import { StorageUtils } from 'src/utils';
import { TUploadApplicationFileAction } from 'src/services/apiEndpoint.types.ts';
import { useUrlParamValue } from 'src/hooks';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { createExternalEventApplication } from 'src/store/externalApplication/externalApplication.slice';
import { assignModalId, resetModalId } from 'src/store/common/common.slice';
import ApplicationSuccessModal, {
  applicationSuccessModalId
} from 'src/components/company/programs/applyToProgramExternal/applicationSuccessModal/ApplicationSuccessModal';
import { ProgramClosed } from 'src/components/company/programs/applyToProgram';
import {
  getEventForExternalUser
} from 'src/store/externalProgram/externalProgram.slice';

import '../applyToProgramExternal/applyToProgramExternal.scss';
import cx from './applyEvent.module.scss'
import DraftDeleteModal from 'src/components/company/programs/applyToProgramExternal/DraftDeleteModal/DraftDeleteModal';
import { Card, Container } from 'react-bootstrap';
import { getViewCompany } from 'src/store/company/company.slice';
import { getUploadEventApplicationFile } from 'src/store/program/program.slice';

const ApplyToEventExternal = () => {
  // Hooks
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { paramValue } = useUrlParamValue();
  const ApplicationDraft: any = StorageUtils.get('ApplicationDraft');
  const data = useAppSelector((store: any) => store.externalApplicationSlice);
  const user = data?.user || '';
  const token = data?.token || '';
  const programData = useAppSelector((store: any) => store.externalProgramSlice);
  const viewEvent = programData?.viewEvent;
  const { viewCompany, viewCompanyProfilePic } = useAppSelector((store) => store.company);
  const modalId: string = useAppSelector((store: any) => store.common.modalId);
  // React hooks
  const [applyProgramStep, setApplyProgramStep] = useState<number>(0);
  const [applicantDetails, setApplicantDetails] = useState<TApplicationDetailsFormValues>({
    name: '',
    email: ''
  });
  const [applicantSectionResponses, setApplicantSectionResponses] = useState<
    { sectionTitle: string; sectionRoles?: string | null; isRole?: boolean, sectionItems: TApplicationFormStepSectionItem[] }[]
  >(viewEvent?.applicationForm?.sections);
  const [applicationFiles, setApplicationFiles] = useState<any>({});
  const [isDraft, setIsDraft] = useState<boolean>(false);
  // const RoleSection = applicantSectionResponses.find((section) => section.sectionTitle === 'Role');
  const RoleSection = applicantSectionResponses.find((section) => section?.isRole);

  // Constants
  const isApplicationSuccessModalOpen = modalId === applicationSuccessModalId;
  const eventId: string = paramValue({ paramName: 'id' }) as string;

  const handleGoBack = () => {
    if (applyProgramStep > 0) {
      setApplyProgramStep((prev) => prev - 1);
    } else {
      navigate('/', { replace: true });
    }
  };

  const handleNext = () => {
    setApplyProgramStep((prev) => {
      if (prev + 1 < steps?.length) {
        return prev + 1;
      }
      return prev;
    });
  };

  const goToApplicationHome = () => {
    // localStorage.removeItem('applicationFormSections')
    setApplicantSectionResponses(viewEvent?.applicationForm?.sections);
    StorageUtils.remove('ApplicationDraft');
    setApplyProgramStep(0);
  };

  const handleGetEvent = () => {
    const payload: any = {
      eventId
    };
    if (eventId && eventId !== '0' && eventId !== '') {
      dispatch(getEventForExternalUser(payload));
    }
  };
  const steps = [
    <ApplyProgramProgramDetails
      key="applyProgramProgramDetails"
      handleGetProgram={handleGetEvent}
      type='event'
    />
  ];

  const updateApplicantSectionResponse = ({
    sectionIndex,
    sectionTitle,
    sectionResponses,
    sectionRoles,
    isRole,
    selectedFiles
  }: {
    sectionIndex: number;
    sectionTitle: string;
    isRole?: boolean;
    sectionRoles?: string | null; l
    sectionResponses: TApplicationFormStepSectionItem[];
    selectedFiles: any;
  }) => {
    console.log(sectionResponses, 'sectionResponses');

    setApplicantSectionResponses((prev) => {
      const currentSections = JSON.parse(JSON.stringify(prev));

      currentSections[sectionIndex] = { sectionTitle, sectionItems: sectionResponses, isRole, sectionRoles };
      if (
        RoleSection?.sectionItems[0]?.id === currentSections[sectionIndex]?.sectionItems[0]?.id &&
        RoleSection?.sectionItems[0].response !==
        currentSections[sectionIndex]?.sectionItems[0].response
      ) {
        const updatedSections = [...currentSections]; // Copy currentSections to avoid mutating the original array

        viewEvent?.applicationForm?.sections?.forEach((appSection, index) => {
          const exists = currentSections.some(
            (currentSection) => currentSection.sectionTitle === appSection.sectionTitle
          );

          if (!exists) {
            // Insert the missing section at the same index as in applicationSections
            updatedSections.splice(index, 0, appSection);
          }
        });

        console.log(updatedSections, 'currentSections', sectionResponses[0].response);
        return updatedSections?.filter(
          (section) =>
            (section?.sectionRoles && JSON.parse(section?.sectionRoles)?.includes(sectionResponses[0].response)) ||
            section?.isRole ||
            !section?.sectionRoles
          // to handle where no role is selected by admin
        );
      }
      return currentSections;
    });

    setApplicationFiles((prev: any) => {
      const output = { ...prev, ...selectedFiles };

      return output;
    });

    handleNext();
  };

  const handleApplyToProgram = ({
    sectionIndex,
    sectionTitle,
    sectionResponses,
    isRole,
    sectionRoles,
    selectedFiles
  }: {
    sectionIndex: number;
    sectionTitle: string;
    isRole?: boolean;
    sectionRoles?: string | null;
    sectionResponses: TApplicationFormStepSectionItem[];
    selectedFiles: any;
  }) => {
    const currentSections = JSON.parse(JSON.stringify(applicantSectionResponses));

    currentSections[sectionIndex] = { sectionTitle, sectionItems: sectionResponses, isRole, sectionRoles };

    const combinedFiles = { ...applicationFiles, ...selectedFiles };
    setIsDraft(false);
    const payload: any = {
      eventId,
      // userId: user?.id,
      // name: applicantDetails?.name,
      // email: applicantDetails?.email,
      // mobile: applicantDetails?.mobile,
      // draftId: ApplicationDraft?.id,
      response: { sections: currentSections }
      // authorizationToken: token
    };
    dispatch(createExternalEventApplication(payload)).then((response: any) => {
      if (response?.status === 200) {
        const applicationId = response?.data?.application?.id || 0;
        if (ApplicationDraft?.id) {
          StorageUtils.remove('ApplicationDraft');
        }
        Object.keys(combinedFiles).forEach((key) => {
          try {
            const files = combinedFiles[key];

            files.forEach((file: any) => {
              const fileBytes: any = file.data;
              if (fileBytes.byteLength > 0) {
                const payload: TUploadApplicationFileAction = {
                  eventId,
                  applicationId,
                  id: file?.key,
                  fileName: file?.fileName,
                  data: file?.data || ''
                };

                dispatch(getUploadEventApplicationFile(payload));
              }
            });
          } catch (e) {
            console.log(e);
          }
        });

        dispatch(assignModalId(applicationSuccessModalId));
      }
    });
  };
  const handleDraft = ({
    sectionIndex,
    sectionTitle,
    isRole,
    sectionRoles,
    sectionResponses,
    selectedFiles
  }: {
    sectionIndex: number;
    sectionTitle: string;
    isRole?: boolean;
    sectionRoles?: string | null;
    sectionResponses: TApplicationFormStepSectionItem[];
    selectedFiles: any;
  }) => {
    const currentSections = JSON.parse(JSON.stringify(applicantSectionResponses));
    currentSections[sectionIndex] = { sectionTitle, sectionItems: sectionResponses, isRole };
    const combinedFiles = { ...applicationFiles, ...selectedFiles };
    const payload: any = {
      eventId,
      // userId: user?.id,
      // name: applicantDetails?.name,
      // email: applicantDetails?.email,
      // mobile: applicantDetails?.mobile,
      draftId: ApplicationDraft?.id,
      Event: viewEvent,
      draft: true,
      response: { sections: currentSections }
      // authorizationToken: token
    };
    dispatch(createExternalEventApplication(payload)).then((response) => {
      if (ApplicationDraft?.id) {
        StorageUtils.remove('ApplicationDraft');
      }
      setIsDraft(true);
      dispatch(assignModalId(applicationSuccessModalId));
      const applicationId = response?.data?.application?.id || '';

      Object.keys(combinedFiles).forEach((key) => {
        try {
          const files = combinedFiles[key];

          files.forEach((file) => {
            const payload: TUploadApplicationFileAction = {
              eventId,
              applicationId,
              id: file?.key,
              fileName: file?.fileName,
              data: file?.data || ''
            };

            dispatch(getUploadEventApplicationFile(payload));
          });
        } catch (e) {
          console.log(e);
        }
      });
    });
  };
  const handleGetCompany = () => {
    dispatch(getViewCompany({ id: viewEvent?.companyId }));
  };
  console.log(applicantSectionResponses, 'applicantSectionResponses');
  
  try {
    applicantSectionResponses?.forEach((section, index) => {
      const { sectionTitle, sectionItems } = section;

      const totalSteps: number = applicantSectionResponses?.length;

      const finalStep: boolean = totalSteps === index + 1;

      steps.push(
        <ApplicationFormStep
          sectionIndex={index}
          isRole={section?.isRole || false}
          key={`${sectionTitle}-${index}`}
          sectionTitle={sectionTitle}
          sectionItems={sectionItems}
          handleNext={handleNext}
          handleDraft={handleDraft}
          sectionRoles={section?.sectionRoles || null}
          finalStep={finalStep}
          updateApplicantSectionResponse={updateApplicantSectionResponse}
          handleApplyToProgram={handleApplyToProgram}
          goToApplicationHome={goToApplicationHome}
          formType='event'
        />
      );
    });
  } catch { }
  console.log(viewCompany, 'viewCompany');

  const handleCloseApplicationSuccessModal = () => {
    dispatch(resetModalId());
    // setApplyProgramStep(0);
    navigate('/dashboard')
  };
  useEffect(() => {
    if (viewEvent?.companyId && viewEvent?.companyId !== '0' && viewEvent?.companyId !== '') {
      handleGetCompany();
    }
  }, [viewEvent?.companyId]);
  useEffect(() => {
    if (eventId && eventId !== '0' && eventId !== '') {
      handleGetEvent();
    }
  }, [window.location.search, eventId]);

  useEffect(() => {
    if (!StorageUtils.get('ApplicationDraft')) {
      setApplicantSectionResponses(viewEvent?.applicationForm?.sections);
    }
  }, [JSON.stringify(viewEvent?.applicationForm?.sections)]);

  useEffect(() => {
    if (ApplicationDraft) {
      console.log(ApplicationDraft?.response?.sections, 'ApplicationDraft?.response?.sections');
      setApplicantSectionResponses(ApplicationDraft?.response?.sections);
    }
  }, []);
  console.log(viewEvent?.banner, 'viewEvent');

  return (
    // <Container>
      <div className={`${cx.eventContainer}`}>
        <TopNavigation />
        <div className={`${cx.eventBody}`}>
          {applyProgramStep > 0 && (
            <BackNavigation
              text={'Back'}
              onClick={handleGoBack}
            />
          )}
          {viewEvent?.banner?.url && <div className={`${cx.bannerBody}`}>
            <Card>
              <img src={viewEvent?.banner?.url} alt="event-banner" />
            </Card>
          </div>}
          {/* <div className="view-company__body__content__body">
          <CompanyInfoCard
            name={viewCompany?.name}
            type="{type}"
            introduction={viewCompany?.introduction}
            website="{website}"
            contactUsUrl="{contactUsUrl}"
            profilePic={viewCompanyProfilePic}
            dropdownItems={[]}
            programBanner={''}
          />
        </div> */}
          <div className={`apply-to-program-external__body__step ${cx.eventFormBody}`}>
            <div className="apply-to-program-external__body__step__component">
              <div className="apply-to-program-external__body__step__component__header">
                <Typography
                  variant="subHeading-2"
                  fontWeight="semiBold"
                  style={{ color: colors.neutral[1100] }}
                >
                  {applyProgramStep === 0 ? viewEvent?.title : 'Event form'}
                </Typography>
              </div>
              {steps[applyProgramStep]}
              {applyProgramStep === 0 && <Button size="small" variant="primary" style={{ maxWidth: '130px' }} onClick={handleNext}>
                Continue
              </Button>}
            </div>
            {/* {applyProgramStep === 0 && viewEvent?.status !== 'Closed' && (
            <ApplicantDetails
              applicantDetails={applicantDetails}
              updateApplicantDetails={updateApplicantDetails}
              handleNext={handleNext}
            />
          )}{' '} */}
            {applyProgramStep === 0 && viewEvent?.status === 'Closed' && (
              <ProgramClosed
                title={viewEvent?.title}
                endDate={viewEvent?.endDate}
                companyName={viewEvent?.company?.name}
              />
            )}
          </div>
        </div>
        <DraftDeleteModal goToApplicationHome={goToApplicationHome} />
        {/* <NavigationModal /> */}
        {isApplicationSuccessModalOpen && (
          <ApplicationSuccessModal
            isModalOpen={isApplicationSuccessModalOpen}
            handleCloseModal={handleCloseApplicationSuccessModal}
            ApplicationDraft={isDraft}
            templateType='event'
          />
        )}
      </div>
    // </Container>
  );
};

export default ApplyToEventExternal;
